import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { checkStorage, saveToStorage } from "../../helpers/localStorage";

let version = checkStorage("__app_version__");
let scheme = checkStorage("colorScheme");
let logo = checkStorage("updatedLogo");

if (Boolean(version) == false) {
  version = process.env.VERSION;
  saveToStorage("__app_version__", version);
}

if (Boolean(scheme) == false) {
  scheme = {
    primary: "#51B67E",
    secondary: "#E1FAF4",
    event: "#2A774C",
    danger: "#dc3545"
  };
}

if (Boolean(logo) == false) {
  logo = {
    status: true,
    image: null
  };
}

// TODO Trigger client to update version if outdated.
// if (version !== process.env.VERSION) {}

const state = () => ({
  view: "mobileView",
  scheme,
  logo,
  version
});

export default {
  state,
  actions,
  getters,
  mutations
};
